export const isWebPushSupported = (('serviceWorker' in navigator) && ('PushManager' in window));
